@if (dialog.state(); as state) {
  <button type="button" class="lem-confirm-backdrop" aria-label="Fermer" (click)="dialog.cancel()"></button>
  <section class="lem-confirm" [attr.data-tone]="state.tone" role="alertdialog" aria-modal="true" aria-labelledby="lem-confirm-title" aria-describedby="lem-confirm-message">
    <div class="lem-confirm__icon">
      <lem-icon [name]="state.tone === 'danger' ? 'trash' : 'alert-triangle'" [size]="24" />
    </div>
    <div class="lem-confirm__content">
      <h2 id="lem-confirm-title">{{ state.title }}</h2>
      <p id="lem-confirm-message">{{ state.message }}</p>
    </div>
    <div class="lem-confirm__actions">
      <button type="button" class="lem-btn lem-btn--secondary" (click)="dialog.cancel()">{{ state.cancelLabel }}</button>
      <button type="button" class="lem-btn" [class.lem-btn--danger]="state.tone === 'danger'" [class.lem-btn--primary]="state.tone !== 'danger'" (click)="dialog.accept()">{{ state.confirmLabel }}</button>
    </div>
  </section>
}
